import { useCallback, useState } from "react";
import AppSidebar from "./AppSidebar";
import TopNav from "./TopNav";
import Footer from "./Footer";

const MainLayout = ({ children }) => {
	const [isMobileOpen, setIsMobileOpen] = useState(false);

	const onMenuToggle = useCallback(() => {
		setIsMobileOpen((prev) => !prev);
	}, []);
	const onCloseMenu = useCallback(() => {
		setIsMobileOpen(false);
	}, []);
	return (
		<div className="min-h-screen font-retro flex flex-col">
			<TopNav onMenuToggle={onMenuToggle} />
			<AppSidebar isMobileOpen={isMobileOpen} onClose={onCloseMenu} />
			<main className="pt-16 transition-all duration-300 flex-1">
				<div className="px-6 lg:px-8 min-h-[90vh]">{children}</div>
			</main>
			<div className="py-2">
				<Footer />
			</div>
		</div>
	);
};

export default MainLayout;
